export const AvailabilityStatusTypes = {
  AvailableNow: "AvailableNow",
  AvailableFuture: "AvailableFuture",
  AvailablePendingUnitTurnDate: "AvailablePendingUnitTurnDate",
  NotAvailable: "NotAvailable",
  NotAvailablePendingUnitTurnDate: "NotAvailablePendingUnitTurnDate",
} as const;

export type AvailabilityStatuses = (typeof AvailabilityStatusTypes)[keyof typeof AvailabilityStatusTypes];

export interface Area {
  value: number;
  units: string;
}

export interface Price {
  basePrice: number;
  currency: string;
  pricePeriod: string;
  leaseDuration: string;
  furnishedPrice?: number;
}

export interface AvailabilityStatus {
  status: AvailabilityStatuses;
  date: string;
}

export interface UnitAttribute {
  "unit.amenities"?: string;
}

export interface Unit {
  fid: string;
  availabilityStatus: AvailabilityStatus;
  prices: Price[];
  name: string;
  betaEligible: boolean;
  attributes: UnitAttribute[];

  //non-deepsky
  external?: {
    specials?: string[];
    applyOnlineUrl?: string;
    sourceUnitId?: string;
    id?: number;
    name?: string;
    isAvailable?: boolean;
    unitStatus?: string;
    makeReadyDate?: string;
    availableDate?: string;
  };
}

export interface UnitType {
  fid: string;
  name: string;
  marketingName: string;
  description: string;
  units: Unit[];
}

export interface MarketingFloorPlanAttribute {
  "marketingFloorplan.amenities"?: string;
}

export interface Media {
  fid: string;
  mimeType: string;

  //non-deepsky
  external?: {
    sourceUrl?: string;
    altText?: string;
  };
}

export interface MarketingFloorPlan {
  name: string;
  numberOfBedrooms: number;
  numberOfBathrooms: number;
  minFloorArea: Area;
  maxFloorArea: Area;
  unitTypes: UnitType[];
  fid: string;
  description: string;
  unitCount: number;
  minPrice: Price;
  maxPrice: Price;
  minFurnishedPrice?: Price;
  maxFurnishedPrice?: Price;
  attributes: MarketingFloorPlanAttribute[];
  media: Media[];

  //non-deepsky
  external?: {
    furnished?: boolean;
  };
}

export interface PropertyAttribute {
  "property.amenities"?: string;
}

export interface Property {
  fid: string;
  name: string;
  description: string;
  attributes: PropertyAttribute[];
  marketingFloorPlans: MarketingFloorPlan[];

  //non-deepsky
  external?: {
    propertyId?: string;
  };
}
